























































































import { Component, Vue } from 'vue-property-decorator'
import { callAppFunc_navigateFeedBack, appFunc_callExit } from '@/utils/bridge'
import { getKf } from '@/api/index'

@Component({
  name: 'Feedback'
})
export default class Feedback extends Vue {
  [x: string]: any
  //   tab栏数组
  collapseBtnList: any = [
    {
      id: 1,
      ch: '1. 遇到色情骚扰、骂人怎么办？',
      desc:
        '您好，举报违规用户有3种方式：1. 点击主页右下角-我的-帮助与反馈 2.私聊：聊天页面中-右上角-点3个点-举报。3.群聊：长按消息或点击对方头像，即可举报。'
    },
    // {
    //   id: 2,
    //   ch: '如何使用拨号功能？',
    //   children: [
    //     {
    //       id: 1,
    //       title: '（1）输入数字拨号：',
    //       content:
    //         '打开软件——选择下工具栏“拨号”页面——点击右下角“键盘浮标”——可直接输入数字拨号。'
    //     },
    //   ]
    // },
    {
      id: 2,
      ch: '2. 怎么提现积分？',
      desc:
        '你好，打开mungdax，点最下方菜单-点击我的-点击积分，页面会显示提现需要满足的积分数量，点击需要兑换的金额，完成实名认证和绑定微信，系统审核后，就可以提现了。'
    },
    {
      id: 3,
      ch: '3. 申请的提现怎么还没到账？',
      desc:
        '您好，请您确保积分兑换现金，将会在3个工作日内到账，周六周日和法定节假日顺延，请您耐心等待，感谢您的理解与支持。'
    },
    {
      id: 4,
      ch: '4. 打款失败的原因？',
      desc:
        '您好，打款失败有以下3种原因：1.当天申请提现超过200元。 2. 绑定的提现微信号，没实名。 3. 平台当日转账金额超出限制。排除以上原因后，会按照正常流程审核，审核时间为1-3个工作日，感谢您的理解与支持。'
    },
    {
      id: 5,
      ch: '5. 优质单身有什么好处呢？',
      desc:
        '您好，成为优质单身后，会有更多异性在这个列表看到你的信息，来找你聊天的人会更多，认识新朋友的概率也更大哦。'
    },
    // {
    //   id: 6,
    //   ch: '6. 征婚广场有什么好处呢？',
    //   desc:
    //     '您好，征婚广场是平台为有强烈找对象用户提供的新平台，在这里您可以通过发布自己的信息，增加寻找缘分的可能。'
    // },
    {
      id: 7,
      ch: '6. 怎么删动态内容？',
      desc: '您好，删除动态方法：点进自己发出的动态，右上角三个点，选择删除。'
    },
    {
      id: 8,
      ch: '7. 信息无法发送/发送失败？',
      desc:
        '您好，消息发送失败有以下3种原因：1.金币余额不足。2.被对方用户屏蔽或拉黑。3.网络不佳。'
    },
    {
      id: 9,
      ch: '8. 实名认证会暴露个人隐私吗？',
      desc:
        '您好，实名认证是对用户资料真实性进行的一种验证，有助于建立完善可靠的聊天环境。您的认证资料仅由第三方验证，mungdax并不会保留您的数据，感谢您的理解与支持。'
    },
    {
      id: 10,
      ch: '9. 被禁言的原因？',
      desc:
        '您好，刷屏、发送不良消息或被其他用户举报，系统将会进行禁言处理，禁言时间过后就可以正常使用了哦。'
    },
    {
      id: 11,
      ch: '10.怎么注销账号？',
      desc: '您好，点击设置后，再点击右上角的三个点，即可注销账号。'
    }
  ]

  //ios问题数组
  IosList: any = [
    {
      id: 1,
      ch: '1. 遇到色情骚扰、骂人怎么办?',
      desc:
        '您好，举报违规用户有3种方式：1. 点击主页右下角-我的-帮助与反馈 2.私聊：聊天页面中-右上角-点3个点-举报。3.群聊：长按消息或点击对方头像，即可举报。'
    },
    {
      id: 2,
      ch: '2. 怎么删动态内容？',
      desc: '您好，删除动态方法：点进自己发出的动态，右上角三个点，选择删除。'
    },
    {
      id: 3,
      ch: '3. 信息无法发送/发送失败？',
      desc:
        '您好，消息发送失败有以下3种原因：1.金币余额不足。2.被对方用户屏蔽或拉黑。3.网络不佳。'
    },
    {
      id: 4,
      ch: '4. 实名认证会暴露个人隐私吗？',
      desc:
        '您好，实名认证是对用户资料真实性进行的一种验证，有助于建立完善可靠的聊天环境。您的认证资料仅由第三方验证，mungdax并不会保留您的数据，感谢您的理解与支持。'
    },
    {
      id: 5,
      ch: '5. 被禁言的原因？',
      desc:
        '您好，刷屏、发送不良消息或被其他用户举报，系统将会进行禁言处理，禁言时间过后就可以正常使用了哦。'
    },
    {
      id: 6,
      ch: '6. 怎么注销账号？',
      desc: '您好，点击设置后，再点击右上角的三个点，即可注销账号。'
    }
  ]

  choose = '' // 点击的collapse Item编号
  setChooseCollapse(item: { id: any }) {
    const chooseCurrent = item.id
    if (this.choose == chooseCurrent) {
      this.choose = ''
      return
    }
    this.choose = chooseCurrent
  }
  // 当前模式
  get mode() {
    const data = this.$route.query.backgroundMode as string
    return data || 'light'
  }

  get isShow() {
    if (/(iPhone|iOS)/i.test(navigator.userAgent)) {
      return true
    } else if (/(Android)/i.test(navigator.userAgent)) {
      return false
    } else {
      return false
    }
  }

  get List() {
    if (/(iPhone|iOS)/i.test(navigator.userAgent)) {
      return this.IosList
    } else if (/(Android)/i.test(navigator.userAgent)) {
      return this.collapseBtnList
    } else {
      return false
    }
  }

  // 当前语言
  get language() {
    return this.$i18n.locale
  }
  // 跳转至问题反馈页
  handelNavigateFeedBack() {
    if (/(iPhone|iOS)/i.test(navigator.userAgent)) {
      this.$router.push({
        path: '/problem',
        query: {
          language: this.language
        }
      })
    } else if (/(Android)/i.test(navigator.userAgent)) {
      callAppFunc_navigateFeedBack()
    } else {
      return false
    }
  }
  async goKf() {
    // const res = await getKf()
    // if (res.code == 1001) {
    //   window.location.href = res.data.positionTwo
    // }

    window.location.href = 'https://work.weixin.qq.com/kfid/kfc892f9c8fb7762f36'
  }
  mounted() {
    const data = (this.$route.query.language as string) || 'ug'
    this.getLanguage(data)
  }
  // 切换语言
  getLanguage(language: string) {
    this.$i18n.locale = language
  }

  handelback() {
    appFunc_callExit()
  }
}
